import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
    Grid,
    makeStyles,
    DialogTitle,
    Dialog,
    DialogActions,
    DialogContent,
    IconButton,
    Button,
    InputAdornment
} from '@material-ui/core';
import {
    TextField,
    Checkboxes,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Switches,
    Autocomplete
} from 'mui-rff';
import { Form, Field } from 'react-final-form';
import * as logger from '../../../logger';
import StateSelectionDialog from '../Dialog/StateSelectionDialog';
import CloseIcon from '@material-ui/icons/Close';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { gstInfoElr, addConsignee, addConsignor, editConsignee, editConsignor } from '../../../store/actions/tripActionCreator';
import TextInputState from '../Inputs/TextInputState';

const useStyles = makeStyles((theme) => ({

    paperWidth: {
        width: 460,
        maxWidth: 460
    },
    paper1: {
        borderRadius: 8
    },
    dialogTitleV1: {
        paddingLeft: 30,
        paddingRight: 18,
        paddingTop: 14,
        paddingBottom: '14px !important',
        '& .MuiTypography-root': {
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        }
    },
    closeButton: {
        color: '#9ea0a5'
    },
    divTitle: {
        fontSize: 20,
        fontWeight: 500,
        textTransform: 'capitalize'
    },
    dialogContentV1: {
        paddingLeft: 30,
        paddingRight: 30,
        paddingTop: 16,
        paddingBottom: 24
    },
    daV1: {
        paddingLeft: 30,
        paddingRight: 30,
        paddingTop: 21,
        paddingBottom: 21
    },
    closeButtonV1: {
        borderRadius: 4,
        textTransform: 'capitalize',
        fontSize: 14,
        fontWeight: 500,
        paddingLeft: 19.5,
        paddingRight: 19.5,
        paddingTop: 7,
        paddingBottom: 7,
        backgroundImage: 'linear-gradient(to top, #f6f7f9, #ffffff) !important',
        marginRight: 16,
        '&:hover': {
            backgroundImage: 'linear-gradient(to top, #f6f7f9, #ffffff) !important'
        }
    },
    confirmButton: {
        borderRadius: 4,
        backgroundColor: '#5170f0',
        color: 'white',
        textTransform: 'capitalize',
        fontSize: 14,
        fontWeight: 500,
        paddingTop: 7,
        paddingBottom: 7,
        paddingLeft: 35,
        paddingRight: 35,
        '&:hover': {
            backgroundColor: '#5170f0'
        }
    },
    divTitleV1: {
        color: '#6b778c',
        fontSize: 12
    },
    textFieldV1: {
        marginTop: 6,
        "& .MuiInputBase-input": {
            paddingTop: '8.5px',
            paddingBottom: '8.5px',
            textTransform: 'uppercase'
        }
    },
    textFieldV2: {
        marginTop: 6,
        "& .MuiInputBase-input": {
            paddingTop: '8.5px',
            paddingBottom: '8.5px',
            textTransform: 'capitalize'
        }
    },
    mtV1: {
        marginTop: 16
    },
    divV1: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 16
    },
    widthV1: {
        width: '48%'
    },
    textFieldV3: {
        marginTop: 6,
        "& .MuiInputBase-input": {
            paddingTop: '8.5px',
            paddingBottom: '8.5px'
        }
    },
    iconV1: {
        color: 'rgba(0, 0, 0, 0.54)'
    },
    disabledButton: {
        borderRadius: 4,
        backgroundColor: '#a1a1a1',
        color: 'white !important',
        textTransform: 'capitalize',
        fontSize: 14,
        fontWeight: 500,
        paddingTop: 7,
        paddingBottom: 7,
        paddingLeft: 35,
        paddingRight: 35,
        '&:hover': {
            backgroundColor: '#a1a1a1'
        }
    }
}));

const AddConsigneeConsignorDetails = ({ open, onClose, onConfirm, edit, checkType, trip, editData, dispatchGstInfoElr, dispatchAddConsignee, dispatchAddConsignor, dispatchEditConsignee, dispatchEditConsignor }) => {

    let submit;

    const classes = useStyles();

    const [dialogOpen, setDialogOpen] = useState(open);
    const [gstNumberValue, setGstNumberValue] = useState("");
    const [stateDialog, setStateDialog] = useState(false);
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [stateName, setStateName] = useState("");
    const [name, setName] = useState("");
    const [address1, setAddress1] = useState("");
    const [address2, setAddress2] = useState("");
    const [pincode, setPincode] = useState("");
    const [mobileNumber, setMobileNumber] = useState("");

    const initialValues = {
        gstNumber: gstNumberValue,
        name: name,
        address1: address1,
        address2: address2,
        state: stateName ? stateName : "",
        pinCode: pincode,
        mobileNumber: mobileNumber ? (mobileNumber.replace(/(\d{5})(\d{5})/, "$1-$2")).trim() : "",
    }

    useEffect(() => {

        if (trip && trip.elrGstInfo) {
            setStateName(trip.elrGstInfo.state);
            setName(trip.elrGstInfo.name);
            setAddress1(trip.elrGstInfo.address_line_1);
            setAddress2(trip.elrGstInfo.address_line_2);
            setPincode(trip.elrGstInfo.pincode);
        }

    }, [trip.elrGstInfo]);

    useEffect(() => {

        if (edit) {
            setGstNumberValue(editData && editData.gst_number ? editData.gst_number : "");
            setStateName(editData && editData.state ? editData.state : "");
            setName(editData && editData.name ? editData.name : "");
            setAddress1(editData && editData.address_line_1 ? editData.address_line_1 : "");
            setAddress2(editData && editData.address_line_2 ? editData.address_line_2 : "");
            setPincode(editData && editData.pincode ? editData.pincode : "");
            setMobileNumber(editData && editData.contact_number ? editData.contact_number : "");
        }

    }, [])

    const validate = values => {

        let config = JSON.parse(localStorage.getItem("USER_APP_CONFIG"));

        let gstValidation = config && config.gstRegex ? new RegExp(config.gstRegex) : "";
        let number = values.mobileNumber ? /^[5-9]{1}[0-9]{9}$/.test(values.mobileNumber.replace("-", "")) : "";

        let gstUpperCase = values.gstNumber ? (values.gstNumber).toUpperCase() : "";
        let pinCodeValidation = config && config.pincodeRegex ? new RegExp(config.pincodeRegex) : "";


        const errors = {};


        if (values.gstNumber && (!gstValidation.test(gstUpperCase))) {
            errors.gstNumber = "Please enter valid GST number"
        }
        if (!values.name) {
            errors.name = "Please enter " + checkType + " name."
        }
        if (values.pinCode && (!pinCodeValidation.test(values.pinCode))) {
            errors.pinCode = "Please enter valid pin code."
        }
        if (values.mobileNumber && !number) {
            errors.mobileNumber = "Please enter valid 10-digit mobile number."
        }

        if (errors && Object.keys(errors).length === 0 && errors.constructor === Object) {
            setButtonDisabled(false);
        } else {
            setButtonDisabled(true);
        }

        return errors;

    }

    const onSubmit = values => {

        trip.elrGstInfo = {};

        const details = {
            address_line_1: values.address1 ? values.address1 : "",
            address_line_2: values.address2 ? values.address2 : "",
            contact_number: values.mobileNumber ? values.mobileNumber.replace("-", "") : "",
            gst_number: values.gstNumber ? values.gstNumber.toUpperCase() : "",
            name: values.name ? values.name : "",
            pincode: values.pinCode ? values.pinCode : "",
            state: values.state ? values.state : ""
        }

        if (edit) {

            if (checkType == "Consignee") {

                dispatchEditConsignee(
                    editData.id,
                    details,
                    (data) => {
                        if (data && data.status && data.status.code == 200) {
                            logger.log('Add Consignee Consignor Dialog Dweb', 'Edit Consignee Successfull');
                            setDialogOpen(false);
                            onConfirm();
                        }
                    },
                    () => {
                        logger.log('Add Consignee Consignor Dialog Dweb', 'Edit Consignee Failed')
                    }
                )

            } else if (checkType == "Consignor") {

                dispatchEditConsignor(
                    editData.id,
                    details,
                    (data) => {
                        if (data && data.status && data.status.code == 200) {
                            logger.log('Add Consignee Consignor Dialog Dweb', 'Edit Consignor Successfull');
                            setDialogOpen(false);
                            onConfirm();
                        }
                    },
                    () => {
                        logger.log('Add Consignee Consignor Dialog Dweb', 'Edit Consignor Failed');
                    }
                )

            }

        } else {
            if (checkType == "Consignee") {
                dispatchAddConsignee(details,
                    (data) => {
                        if (data && data.status && data.status.code == 200) {
                            logger.log('Add Consignee Consignor Dialog Dweb', 'Add Consignee Successfull');
                            setDialogOpen(false);
                            onConfirm();
                        }
                    },
                    () => {
                        logger.log('Add Consignee Consignor Dialog Dweb', 'Add Consignee Failed');
                    }
                )
            } else if (checkType == "Consignor") {
                dispatchAddConsignor(details,
                    (data) => {
                        if (data && data.status && data.status.code == 200) {
                            logger.log('Add Consignee Consignor Dialog Dweb', 'Add Consignor Successfull');
                            setDialogOpen(false);
                            onConfirm();
                        }
                    },
                    () => {
                        logger.log('Add Consignee Consignor Dialog Dweb', 'Add Consignor Failed');
                    }
                )
            }
        }


    }

    const getFormFields = (values) => {
        return [
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.divTitleV1}>We will be fetching details from GST Number</div>
                    </>
                )
            },
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.mtV1}>
                            <div className={classes.divTitleV1}>GST Number</div>
                            <TextInputState
                                placeholder="GST Number"
                                name="gstNumber"
                                variant="outlined"
                                size="small"
                                className={classes.textFieldV1}
                                onChange={(e) => handleGstNumberInfo(e.target.value)}
                            />
                        </div>
                    </>
                )
            },
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.mtV1}>
                            <div className={classes.divTitleV1}>{checkType} Name*</div>
                            <TextInputState
                                placeholder={checkType + " Name"}
                                name="name"
                                variant="outlined"
                                size="small"
                                className={classes.textFieldV2}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </div>
                    </>
                )
            },
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.mtV1}>
                            <div className={classes.divTitleV1}>{checkType} Address Line 1</div>
                            <TextInputState
                                placeholder={checkType + " Address Line 1"}
                                name="address1"
                                variant="outlined"
                                size="small"
                                className={classes.textFieldV3}
                                onChange={(e) => setAddress1(e.target.value)}
                            />
                        </div>
                    </>
                )
            },
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.mtV1}>
                            <div className={classes.divTitleV1}>{checkType} Address Line 2</div>
                            <TextInputState
                                placeholder={checkType + " Address Line 2"}
                                name="address2"
                                variant="outlined"
                                size="small"
                                className={classes.textFieldV3}
                                onChange={(e) => setAddress2(e.target.value)}
                            />
                        </div>
                    </>
                )
            },
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.divV1}>
                            <div className={classes.widthV1}>
                                <div className={classes.divTitleV1}>State</div>
                                <TextField
                                    placeholder="State"
                                    name="state"
                                    variant="outlined"
                                    size="small"
                                    className={classes.textFieldV3}
                                    onClick={() => handleStateSelect()}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <KeyboardArrowDownIcon className={classes.iconV1} />
                                            </InputAdornment>
                                        )
                                        // readonly: true
                                    }}
                                    inputProps={{
                                        readOnly: true
                                    }}
                                />
                            </div>
                            <div className={classes.widthV1}>
                                <div className={classes.divTitleV1}>Pincode</div>
                                <TextInputState
                                    placeholder="Pincode"
                                    name="pinCode"
                                    variant="outlined"
                                    size="small"
                                    className={classes.textFieldV3}
                                    onChange={(e) => setPincode(e.target.value)}
                                />
                            </div>
                        </div>
                    </>
                )
            },
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.mtV1}>
                            <div className={classes.divTitleV1}>Mobile Number</div>
                            <TextInputState
                                placeholder="Mobile Number"
                                name="mobileNumber"
                                variant="outlined"
                                size="small"
                                className={classes.textFieldV3}
                                fieldProps={{
                                    parse: value => value ? (value.replace(/(\d{5})(\d{5})/, "$1-$2")).trim() : ""
                                }}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            +91
                                        </InputAdornment>
                                    ),
                                }}
                                onChange={(e) => setMobileNumber(e.target.value)}
                            />
                        </div>
                    </>
                )
            },
        ]
    }

    const handleClose = () => {
        trip.elrGstInfo = {};

        setDialogOpen(false);
        onClose();
    }

    const handleGstNumberInfo = (gstNumber) => {

        setGstNumberValue(gstNumber);

        let config = JSON.parse(localStorage.getItem("USER_APP_CONFIG"));

        let gstValidation = config && config.gstRegex ? new RegExp(config.gstRegex) : "";
        let gstUpperCase = gstNumber ? (gstNumber).toUpperCase() : "";

        if (gstNumber && (gstValidation.test(gstUpperCase))) {
            dispatchGstInfoElr(gstUpperCase,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log('Add Company Details Dialog Dweb', 'Get GST info elr successfull');
                    }
                },
                () => {
                    logger.log('Add Company Details Dialog Dweb', 'Get GST info elr failed');
                }
            );
        }
    }

    const handleStateSelect = () => {
        setStateDialog(true);
    }

    const handleStateDialogClose = () => {
        setStateDialog(false);
    }

    const handleSelectedState = (value) => {
        setStateName(value);
        setStateDialog(false);
    }

    return (
        <>
            <Dialog fullWidth={true} maxWidth={'sm'}
                onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="add-consignee-consignor-dialog" open={dialogOpen} classes={{ paper: classes.paper1, paperWidthSm: classes.paperWidth }}>

                <DialogTitle className={classes.dialogTitleV1}>
                    <div className={classes.divTitle}>
                        {!edit &&
                            <span>Add&nbsp;{checkType}</span>
                        }
                        {edit &&
                            <span>Edit&nbsp;{checkType}</span>
                        }
                    </div>
                    <IconButton onClick={() => { handleClose() }} className={classes.closeButton}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers className={classes.dialogContentV1}>
                    <Form
                        onSubmit={onSubmit}
                        initialValues={initialValues}
                        validate={validate}
                        id="myForm"
                        render={({ handleSubmit, form, submitting, pristine, values }) => {
                            submit = handleSubmit
                            return (
                                <form onSubmit={handleSubmit} noValidate id="myForm">
                                    <Grid container alignItems="flex-start">
                                        {getFormFields(values).map((item, idx) => item.visible ? (
                                            <Grid item xs={item.size} key={idx}>
                                                {item.field}
                                            </Grid>
                                        ) : null)}
                                    </Grid>
                                    {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
                                </form>
                            )
                        }}
                    />
                </DialogContent>


                <DialogActions className={classes.daV1}>
                    <Button variant="contained" className={classes.closeButtonV1} onClick={() => { handleClose() }}>
                        Close
                    </Button>
                    <Button variant="contained" className={classes.confirmButton} type="submit" disabled={buttonDisabled}
                        classes={{ disabled: classes.disabledButton }}
                        onClick={event => {
                            submit(event)
                        }}
                    >
                        Confirm
                    </Button>
                </DialogActions>

            </Dialog>

            {stateDialog && <StateSelectionDialog open={stateDialog} onClose={handleStateDialogClose} onSelect={handleSelectedState} />}

        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchGstInfoElr: (gstNumber, onSuccess, onFailure) => {
        dispatch(gstInfoElr(gstNumber, onSuccess, onFailure))
    },
    dispatchAddConsignee: (details, onSuccess, onError) => {
        dispatch(addConsignee(details, onSuccess, onError))
    },
    dispatchAddConsignor: (details, onSuccess, onError) => {
        dispatch(addConsignor(details, onSuccess, onError))
    },
    dispatchEditConsignee: (id, details, onSuccess, onError) => {
        dispatch(editConsignee(id, details, onSuccess, onError))
    },
    dispatchEditConsignor: (id, details, onSuccess, onError) => {
        dispatch(editConsignor(id, details, onSuccess, onError))
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(AddConsigneeConsignorDetails);